import { ContactPropertyPinAddress, IContactPropertyMapPin, IContactPropertyMapPinResponse } from '@/bundles/Contacts/types';

// A pin at one of the contact's properties. `id` stays the contact's key, so the popup
// and the table-row hover still resolve the contact from any of its pins.
export class ContactPropertyMapPin implements IContactPropertyMapPin {
  readonly id: string;
  readonly lat: number;
  readonly lng: number;
  readonly number: number;
  readonly propertyKey: string;
  readonly propertyAddress: ContactPropertyPinAddress;

  constructor (data: IContactPropertyMapPinResponse, number: number) {
    this.id = data._key;
    this.lat = data.lat;
    this.lng = data.long;
    this.number = number;
    this.propertyKey = data.property_key;
    this.propertyAddress = data.property_address;
  }
}
